import React from 'react'
import { Link } from 'react-router-dom'

export default function CustomerTableRows(props) {
    if(props.rows.length > 0) {
        return props.rows.map((row, index) => (
            <tr key={row.id}>
                <td>{ index + 1 }</td>
                <td>{ row.name }</td>
                <td>{ row.api_url }</td>
                <td>{ row.fb_page_id }</td>
                <td>{ row.fb_page_name }</td>
                <td>
                    {
                        row.is_active === "1" ?
                        <span className="badge badge-success">Active</span> :
                        <span className="badge badge-danger">Inactive</span>
                    }
                </td>
                <td>{ row.created_at }</td>
                <td>
                    <Link to="#" title="Edit Customer Details"><i className="fas fa-edit"></i></Link>&nbsp;&nbsp;&nbsp;
                    <Link to="#" title="Delete Customer Details"><i className="fas fa-trash"></i></Link>
                </td>
            </tr>
        ))
    }
    else {
        return (
            <tr>
                <td className="text-center my-3">No Data Found.</td>
            </tr>
        )
    }
}
